import { action } from '@reatom/framework'

import { Result } from '@blade/std-lib'
import { Network } from '@root/entities/network'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { ApiError, apiRequest } from '@root/shared/api'

import * as UserProfileHoldingsWallet from '../model/user-profile-holdings-wallet'

import type { DelugeId } from '@root/entities/user-short'

type HoldingsRequestParams = {
  network: Network.Network
  delugeId: DelugeId
}

export const holdingsRequestAction = action(
  async (ctx, params: HoldingsRequestParams) => {
    const {
      tradeApiClient,
      environment: {
        assets: { tokenLogosHost },
      },
    } = ctx.get(dependenciesAtom)

    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.user.userProfileHoldingsList, [
        {
          network: Network.toDto(params.network),
          delugeId: params.delugeId,
        },
      ]),
    )

    return result.pipe(
      Result.map((data) =>
        data.wallets.map((wallet) =>
          UserProfileHoldingsWallet.fromDto(wallet, {
            network: params.network,
            tokenLogosHost,
          }),
        ),
      ),
      Result.mapError(ApiError.fallbackToUnknown),
    )
  },
  'holdingsRequestAction',
)
